import { LINE_CLEARANCE_API } from "api/url_helper";

export const PERMISSION_MODULES = {
  ROLE: "Role",
  STUDY: "Study",
  USER: "User",
  WORKFLOW: "Workflow",
  TEMPLATE: "Template",
  DESIGN: "Design",
  CRF: "CRF",
  SUBJECT_CRF: "Subject CRF",
  CRF_QUERY: "CRF Query",
  ALIQUOT: "Aliquot",
  SPONSOR: "Sponsor",
  VOLUNTEER: "Volunteer",
  ADVERSE_EVENT: "Adverse Event",
  TRAINING_GROUP: "Training Group",
  PERIOD: "Period",
  PROTOCOL: "Protocol",
  CODE_LIST: "Codelist",
  ICF: "ICF",
  CHECKLIST: "Checklist",
  STUDY_ATTACHMENT: "Study Attachment",
  IP_INVENTORY: "IP Inventory",
  DISPENSING_LOG: "Dispensing Log",
  RETURNS_LOG: "Returns Log",
  STOCK_RECONCILIATION: "Stock Reconciliation",
  STUDY_SCREENING: "Study Screening",
  DOCUMENT_MANAGEMENT: "Document Management",
  WORKFLOW_QUERY: "Workflow Query",
  DRUG_RETENTION: "Retention",
  DRUG_DISPOSAL: "Disposal",
  DRUG_TRANSFER: "Transfer",
  CLINICAL: "Clinical",
  LABELS: "Labels",
  SESSION: "Session",
  AUDIT_TRAIL: "Audit Trail",
  STUDY_DESIGN: "Study Design",
  PARTICIPANTS: "Participants",
  SUBJECTS: "Subjects",
  TIME_POINT: "Time Point",
  DOSING_SCHEDULE: "Dosing Schedule",
  SUBJECT_CHECKIN: "Subject Check-In",
  SUBJECT_CHECKOUT: "Subject Check-Out",
  SUMMARY_REPORTS: "Summary Reports",
  SUBJECT_LABEL: "Subject Label",
  SUBJECT_ICARD_LABEL: "Subject Icard Label",
  VACUTAINER_LABEL: "Vacutainer Label",
  RIAVIAL_LABEL: "Riavial Label",
  DISPENSING_LABEL: "Dispensing Label",
  GLOBAL_STUDIES: "Global Study Access",
  DASHBOARD: "Dashboard",
  AMBULATORY_VISIT: "Ambulatory Visit",
  BLOCKED_VOLUNTEER: "Blocked Volunteer",
  TRANSFER_VOLUNTEER: "Transfer Volunteer",
  DROPOUT_VOLUNTEER: "Dropout Volunteer",
  SETTINGS: "Settings",
  MODULE_MANAGEMENT: "Module Management",
  LINE_CLEARANCE: "Line Clearance",
  SESSION_PARTICIPANTS: "Session Participants",
  BED_MANAGEMENT: "Bed Management",
  IP_STORAGE: "IP Storage",
  POST_STUDY_ASSESSMENT: "Post Study Assessment",
  DISPATCH: "Dispatch",
  STORAGE: "Storage",

} as const;

export const PERMISSION_ACTIONS = {
  VIEW: "VIEW",
  ADD: "ADD",
  EDIT: "EDIT",
  DEACTIVATE: "DEACTIVATE",
  REOPEN: "REOPEN",
  RESPOND: "RESPOND",
  CLOSE: "CLOSE",
  RENAME: "RENAME",
  ASSIGN_RIGHTS: "ASSIGN RIGHTS",
  DOWNLOAD: "DOWNLOAD",
  ADD_VALUES: "ADD VALUE",
  ASSIGN_STUDY: "ASSIGN STUDY",
  VERIFY: "VERIFY",
  ADD_ACTUAL_COUNT: "ADD ACTUAL COUNT",
  EDIT_ACTUAL_COUNT: "EDIT ACTUAL COUNT",
  ASSIGN_TO_MODULE: "ASSIGN TO MODULE",
  ASSIGN_TRAINING_TO_GROUP: "ASSIGN TRAINING TO GROUP",
  STOCK_SUMMARY_REPORT: "STOCK SUMMARY REPORTS",
  STOCK_LEDGER_REPORT: "STOCK LEDGER REPORTS",
  STOCK_EXPIRY_SOON_REPORT: "STOCK EXPIRY SOON REPORTS",
  SUBJECT_WISE_STOCK_REPORT: "SUBJECT WISE STOCK REPORTS",
  EXPORT_CSV: "EXPORT CSV",
  AUDIT: "AUDIT",
  ASSIGN_ROLE: "ASSIGN ROLE",
  SAVE_SCHEDULE: "SAVE SCHEDULE",
  FETCH_LMS_STATUS: "FETCH LMS STATUS",
  SCAN: "SCAN",
  CHECK_IN: "CHECK-IN",
  CHECK_OUT: "CHECK-OUT",
  PRINT: "PRINT",
  FETCH_PRINT_STATUS: "FETCH PRINT STATUS",
  ALCOHOLTEST_ADD:"ALCOHOLTEST-ADD",
  ALCOHOLTEST_EDIT:"ALCOHOLTEST-EDIT",
  ALCOHOLTEST_AUDIT:"ALCOHOLTEST-AUDIT",
  LABTEST_ADD:"LABTEST-ADD",
  LABTEST_EDIT:"LABTEST-EDIT",
  LABTEST_AUDIT:"LABTEST-AUDIT",
  LABTEST_VIEW:"LABTEST-VIEW",
  LABTEST_DOWNLOAD:"LABTEST-DOWNLOAD",
  LABTEST_VERIFY:"LABTEST-VERIFY",
  ICF_ADD:"ICF-ADD",
  ICF_AUDIT:"ICF-AUDIT",
  SCREENING_ADD:"SCREENING-ADD",
  SCREENING_EDIT:"SCREENING-EDIT",
  SCREENING_AUDIT:"SCREENING-AUDIT",
  SCREENING_DEACTIVATE:"SCREENING-DEACTIVATE",
  SCREENING_CRF_ADD:"SCREENING-CRF-ADD",
  DECIDE_SCREENING_RESULT:"DECIDE-SCREENING-RESULT",
  SESSION_OPERATIONS:"SESSION-OPERATIONS",
  VACUTAINER_TO_ALIQUOT:"VACUTAINER-TO-ALIQUOT",
  SUBJECT_TO_VACUTAINER:"SUBJECT-TO-VACUTAINER",
  ALL_STUDIES:"ALL-STUDIES",
  PARTICIPATION_BASED_STUDIES:"PARTICIPATION-BASED-STUDIES",
  ASSIGN_SUBJECTS:"ASSIGN-SUBJECTS",
  START_VISIT:"START-VISIT",
  COMPLETE_VISIT:"COMPLETE-VISIT",
  PERFORM_ACTIVITIES:"PERFORM-ACTIVITIES",
  BLOCK_SUBJECT:"BLOCK-SUBJECT",
  TRANSFER_VOLUNTEER:"TRANSFER-VOLUNTEER",
  DROPOUT_SUBJECT:"DROPOUT-SUBJECT",
  COMPLETE_STUDY:"COMPLETE-STUDY",
  ARCHIVE_STUDY:"ARCHIVE-STUDY",
  MANAGE_MODULES:"MANAGE-MODULES",
  MANAGE_SETTINGS:"MANAGE-SETTINGS",
  LINE_CLEARANCE_PERFORM:"LINE-CLEARANCE-PERFORM",
  LINE_CLEARANCE_REVIEW:"LINE-CLEARANCE-REVIEW",


} as const;
